import { render, staticRenderFns } from "./payrollRequisitionList.vue?vue&type=template&id=53dff3a0&scoped=true"
import script from "./payrollRequisitionList.vue?vue&type=script&lang=ts"
export * from "./payrollRequisitionList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dff3a0",
  null
  
)

export default component.exports